<template>
  <div class="custom-margin-full-page">
    <img src="@/assets/shape-02.png" alt="shape" class="login-shape">
    <v-card elevation="0" class="lessons-container mt-16">
      <v-card-title class="my-11">درس های من</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
             {{courseName}}
          </v-col>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large
                    @click="$router.push('/dashboard/my-courses')">mdi-arrow-left
            </v-icon>
          </v-col>
          <v-col cols="9">
            <v-row>
              <v-col cols="1" class="mx-0 px-1" v-for="(lesson,index) in details" :key="lesson.id">
                <v-btn v-if="lesson.status === 'open'" color="#1ab69d" class="normal-button" block elevation="0"
                       @click="$router.push('/dashboard/my-courses/item/'+lesson.id+'/'+classId+'/'+courseId)">
                  {{ index + 1 }}
                </v-btn>
                <v-btn v-else disabled color="black" class="normal-button" block elevation="0">
                  {{ index + 1 }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="3">
            <v-row>
              <v-col cols="12">
                تعداد درس های باز: &nbsp;
                {{ details.filter(lesson => lesson.status === 'open').length }}
                عدد
              </v-col>
              <v-col cols="12">
                تعداد درس های بسته : &nbsp;
                {{ details.filter(lesson => lesson.status === 'close').length }}
                عدد
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MyLessonsDesktop",
  props: ['details', 'classId','courseId','courseName'],
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 0 10vw 0 10vw;
}

.normal-button {
  letter-spacing: normal;
  color: white;
}

.login-shape {
  top: 10.8vh;
  right: 9.2vw;
  position: absolute !important;
  z-index: 2;
}

.lessons-container {

}
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}
</style>